import {Dayjs} from "dayjs";


export enum DAY {
    SUNDAY = 1,
    MONDAY = 2,
    TUESDAY = 3,
    WEDNESDAY = 4,
    THURSDAY = 5,
    FRIDAY = 6,
    SATURDAY = 7,
}

export enum DAY_LABEL {
    SUNDAY = 'sunday',
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
}

export interface BlackoutDateProps {
    id?: number;
    title?: string;
    fromDate?: Date;
    fromDay?: DAY | number;
    fromTime: number;
    toDate?: Date;
    toDay?: DAY | number;
    toTime: number;
}

export interface NewBlackoutDateProps {
    id?: number;
    title?: string;
    fromDate: Dayjs | null;
    fromDay?: DAY | number;
    fromDayTime?: number;
    fromDateTime?: number;
    toDate: Dayjs | null;
    toDay?: DAY | number;
    toDayTime?: number;
    toDateTime?: number;
}